import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FreightForwarder } from '../models/freight-forwarder.model';

@Injectable({
  providedIn: 'root'
})
export class FreightForwarderService {

  private readonly http = inject(HttpClient);
  private readonly restApiUrl = `${environment.restApiUrl}freight-forwarder-endpoint`;

  addFreightForwarder(freightForwarder: FreightForwarder): Observable<FreightForwarder> {
    return this.http.post<FreightForwarder>(this.restApiUrl, freightForwarder);
  }

  getFreightForwarder(countryId?: number | null, freightForwarderId?: number | null, crNumber?: number | null, phoneNumber?: string | null, emailAddress?: string | null): Observable<FreightForwarder> {
    const params: any = {};
    if (countryId) params.countryId = countryId;
    if (freightForwarderId) params.freightForwarderId = freightForwarderId;
    if (crNumber) params.crNumber = crNumber;
    if (phoneNumber) params.phoneNumber = phoneNumber;
    if (emailAddress) params.emailAddress = emailAddress;

    return this.http.get<FreightForwarder>(this.restApiUrl, { params });
  }
}
